let hostname = window.location.hostname;
//console.log(hostname)
//let api_ip;
/*
if (hostname) {
  api_ip = hostname;
  //console.log(api_ip)
}
*/
let URL = null;
let IMG_DIR_URI = null;

if (hostname === "app.gambiaports.gm" || hostname === "clinic.gambiaports.gm") {
  URL = "https://api.v1.gambiaports.gm/api/v1/res";
  IMG_DIR_URI = "https://api.v1.gambiaports.gm/static/images/";
} else {
  URL = "http://" + hostname + ":5100/api/v1/res"; //5100
  IMG_DIR_URI = "http://" + hostname + ":5100/static/images/"; //5100
}
//export const API_URL = "http://" + hostname + ":5000/api/v1/res";
//oo
//export API_URL; //= "http://api.v1.gambiaports.gm/api/v1/res";
//export const API_URL = "http://192.168.254.14:5000/api/v1/res";
//export const API_URL = "http://localhost:5000/api/v1/res";
export const API_URL = URL; //"http://192.168.254.14:5000/api/v1/res";
export const IMG_DIR = IMG_DIR_URI; //"http://" + hostname + ":5100/static/images/";
export const LOGO_URI = "https://app.gambiaports.gm/images/"; //"http://localhost:8080/images/"; //
export default { API_URL, IMG_DIR, LOGO_URI };
